export const RRS_INTEREST_RATE = {
  type: 'article',
  image: 'https://scoopr.no/static/media/person_yellow.0b4f9641.webp',
  headline: 'Rente – hva er egentlig det?',
  url: 'https://scoopr.no/rente-hva-er-egentlig-det',
  description:
    'Når vi skal ta opp et lån er det for de fleste av oss én ting som er viktig, nemlig renten. Men hva er egentlig rente? Hva betyr nominell og effektiv rente, hva er forskjellen på dem og ikke minst – hvilken av disse to rentene bør avgjøre hvilket lån du velger?',
  datePublished: '2021-12-10T08:00:00+00:00',
  dateModified: '2022-01-26T08:00:00+00:00',
};
